<template>
	<div id="" ref="">
		<input type="file" ref="idImgFile" style="display:none;" accept=".jpg,.png" @change="onImgChange"/>

		<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:6px; margin-left:10px;" @click="onFileClick">{{getLangText("选择文件")}}</div>
		<div ref="idImgPath" style="float:left; margin-top:7px; text-indent:10px; width:350px; height:30px; line-height:30px; border:0px solid red;"></div>
		<div style="float:left; width:490px; height:272px; margin-top:10px; border:1px solid #bbbbbb; display:flex; flex-direction:column; align-items:center;">
			<img ref="idImgPan" style="flex:0 0 auto; float:left; border:0px solid red;">
		</div>
		<div style="float:left; width:100%; height:12px; margin-top:3px;">
			<div style="float:left; width:490px; height:12px; border-radius:5px; border:1px solid #2a83cf; margin-top:6px; display:block; position:relative;">
				<div style="position:absolute; width:0%; height:10px; line-height:10px; border-radius:5px; background:#b4ea74;" ref="idProgBar"></div>
				<div style="position:absolute; width:100%; height:10px; line-height:10px; color:#2a83cf; text-align:center; font-size:8px; font-style: italic;" ref="idProgCapt"></div>
			</div>
		</div>
		<div style="float:left; width:100%; height:40px; border:0px solid red;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onUploadClick">{{getLangText("上传")}}</div>
		</div>
	</div>
</template>

<script>

import { SuperGif } from "./libgif"

export default {
	name: 'SourceNew',
	components:{

	},
	data () {
		return {
			prog: 0,
			imgW: 0,   //图片的原始宽度
			imgH: 0,   //图片的原始高度
			FName: "", //素材名
		}
	},
	mounted: function(){

	},
	computed:{

	},
	methods:{
		onImgChange: function(){
			let file=this.$refs["idImgFile"];
			let image = new Image();
		    let bytes=0;                     //图片的字节数
		    let that=this;
		    image.onload=function(){
		    	that.imgW=image.width;       //图片的原始宽度
		    	that.imgH=image.height;      //图片的原始高度
		    	let bl=true;

		    	/*if( pRCall )
		    	{
		    		if( pTy == "gif" )
		    		{
						var rub = new SuperGif({ gif: image} );
						rub.load(function(){
							if( pRCall ) bl = pRCall(that.imgW, that.imgH, bytes, rub.get_length());
			          	});
		    		}
		    		else
		    		{
		    			bl=pRCall(that.imgW, that.imgH, bytes, 0);  // 原始宽度, 原始高度, 字节数, 时间长度
		    		}
		    	}*/

		    	if( bl )
		    	{
			    	let wh=that.getZoomSize(490, 270, that.imgW, that.imgH);     //计算缩放后的规格
			    	that.$refs["idImgPan"].style["width"]  = wh[0]+"px";    //置缩放后的宽度
			    	that.$refs["idImgPan"].style["height"] = wh[1]+"px";    //置缩放后的高度
			    	that.$refs["idImgPan"].src = image.src;

			        //setTimeout( that._getBase64, 100 );
		    	}
		    };

			let filePic = file.files[0];

			that.FName = filePic.name.split(".")[0];
			that.FName = that.FName.replace(/&/g, "");
			that.FName = that.FName.replace(/=/g, "");
			that.FName = that.FName.replace(/'/g, "");
			that.FName = that.FName.replace(/‘/g, "");
			that.FName = that.FName.replace(/“/g, "");
			that.FName = that.FName.substring( that.FName.length-30, 30 );

			this.$refs["idImgPath"].innerText = filePic.name;
			if( !filePic ) return;

			bytes = filePic.size;
		    let reader = new FileReader();
		    reader.onload = function (e) {
		        let data = e.target.result;
		        image.src = data;
		    };
		    reader.readAsDataURL(filePic);
		},
		onFileClick: function(){
			this.$refs["idImgFile"].files = null;
			this.$refs["idImgFile"].click();
		},
		/* 上传文件 */
		onUploadClick: function(){
			if( this.$refs["idImgFile"].files.length==0 ) return;

			this.prog = 0;
			this.$refs["idProgBar"].style["width"] = this.prog+"%";
			this.$refs["idProgCapt"].innerText = this.prog+"%";

			this.doUpload( ServAddr+"/api/pub/fileUpload", this.$refs["idImgFile"].files[0], true, this.onFileFinish, this.ProgressBar )
		},
		ProgressBar: function( evt ){
			// event.total是需要传输的总字节，event.loaded是已经传输的字节。
			// 如果event.lengthComputable不为真，则event.total等于0
			let v=parseInt(evt.loaded * 100 / evt.total);
			this.$refs["idProgBar"].style["width"] = v+"%";
			this.$refs["idProgCapt"].innerText = v+"%";
		},
		onFileFinish: function( res ){
			this.appRoot.app.closeDlgRun();

			if( res.code == 200 )   // 上传成功
			{
				let body={ siNameEng:this.FName, siCustId: this.login.custId,
							siImgType: parseInt(this.$route.query.imgType),
							siPasterType: parseInt(this.$route.query.pasterType),
							siEquityLevel: 132,
							siSize: this.imgW+","+this.imgH, siImgPath:res.body.filePath };
				this.doTrade( "POST", ServAddr+"/api/source/sourceAdd", this.onSourceAddOK, true, body, null );
			}
			else
			{
				this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err );
			}
		},
		onSourceAddOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("上传成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SourceNew.vue?60ed5b4e